import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';

import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import { ViewRow, WinningPercentageService } from '../../core';
import { ActionType } from '../main.action';

import {
    ExpandRow,
    ExpandRowCancel,
    expandRowResult,
} from './expand-row.action';

export const expandRowEpic = (
    action: ActionsObservable<PayloadAction<ActionType, ExpandRow>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.WP_MAIN__EXPAND_ROW),
        mergeMap((act: PayloadAction<ActionType, ExpandRow>) => {
            const service = deps.injector.get<WinningPercentageService>(
                WinningPercentageService,
            );

            // TODO change to graphql
            return service
                .listRows(
                    act.payload.drillPathIdentifier,
                    act.payload.segmentIdentifier,
                    act.payload.paramsAtSegment,
                )
                .pipe(
                    map((ret: ViewRow[]) => {
                        return expandRowResult(
                            {
                                ...act.payload,
                                rows: ret,
                            },
                            act.storePath,
                        );
                    }),
                    catchError((err) => {
                        console.log(err);
                        return of(null);
                    }),
                    takeUntil(
                        action.pipe(
                            ofType(ActionType.WP_MAIN__EXPAND_ROW_CANCEL),
                            filter(
                                (
                                    cancelAct: PayloadAction<
                                        ActionType,
                                        ExpandRowCancel
                                    >,
                                ) =>
                                    cancelAct.storePath === act.storePath &&
                                    cancelAct.payload.rowId ===
                                        act.payload.rowId,
                            ),
                        ),
                    ),
                );
        }),
    );
